import { Reducer } from 'redux';
import { IRegionConfigsState, RegionConfigDashboardTypes } from './types';

const initialState: IRegionConfigsState = [];

const reducer: Reducer<IRegionConfigsState> = (state = initialState, action) => {
  switch (action.type) {
    case RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS_SUCCESS:
    case RegionConfigDashboardTypes.GET_ALL_FILTER_REGION_CONFIGS_SUCCESS: {
      const result = [...action.payload].map(item => {
        const sortValue = item.docType === 'DEFAULT' ? 1 : 2;
        return { ...item, sortValue };
      });
      result
        .sort((a: any, b: any) => (a.sortValue > b.sortValue ? 1 : a.sortValue < b.sortValue ? -1 : 0))
        .forEach(function (item) {
          delete item.sortValue;
        });
      return result;
    }

    default:
      return state;
  }
};

export { reducer as regionConfigDashboardReducer };
